export default __webpack_public_path__ + "static/logo-source-d90548183461ab94a8b553b6ae78b093.svg";